import { getSubdomainFromURL } from './get-subdomain'

export const getClientSubdomain = () => {
  if (typeof window === 'undefined') {
    return null
  }

  return getSubdomainFromURL(window.location.hostname)
}
